module.exports = __webpack_public_path__ + "img/safety-icon-2.a71cacf1.png";